exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".cancel-page .section-title[data-v-6aa4560c] {\n  padding-bottom: 2em;\n}\n.cancel-page .back-row[data-v-6aa4560c] {\n  margin-top: 1.5em;\n  margin-left: 1em;\n}\n.cancel-page .cancel-sub-btn[data-v-6aa4560c] {\n  padding: 2em 0;\n}\n", ""]);

// exports
